<template>
  <f-box 
    class="subscription-list-item margin-bottom-3 has-col-12"
    grid
  >
    <div class="is-col-3 has-col-6 is-grid is-aligned-left">
      <div class="is-col-3 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b>
              {{ formatDate(subscription.begin) }}
            </b>
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b>
            {{ formatDate(subscription.end) }}
          </b>
          </small>
        </p>
      </div>
    </div>

    <div class="is-col-9 has-col-12 is-grid is-aligned-left">
      <div class="is-col-2 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b>
              {{ subscription.amount }} €
            </b>
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b>
              {{ subscription.name }}
            </b>
          </small>
        </p>
      </div>

      <div class="is-col-2 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b v-if="subscription.reduction">
              {{ subscription.reduction.code }}
            </b>
          </small>
        </p>
      </div>

      <div class="is-col-2 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b v-if="subscription.payment">
              {{ formatDate(subscription.payment.charges_at) }}
            </b>
          </small>
        </p>
      </div>

      <div class="is-col-3 is-aligned-left">
        <p class="is-ellipsis">
          <small>
            <b v-if="subscription.payment">
              {{ status }}
            </b>
          </small>
        </p>
      </div>
    </div>
  </f-box>
</template>

<script>
  import { ref, computed, watch } from 'vue'
  import useDate from '@composables/use-date'
  import Constants from '@freebe/sdk/constants'
  
  export default {
    props: {
      subscription: {
        type: Object,
        required: true,
      },

      selectable: {
        type: Boolean, 
        default: true,
      },

      isSelected: {
        type: Boolean, 
        default: false,
      },
    },

    setup (props, context) {
      const selected = ref(!!props.selected)

      const status = computed(() => 
        Constants.subscriptions.statusDescription[props.subscription.payment?.status]
      )

      function toggleSelection () {
        context.emit('toggle-selection', props.subscription._id, !!props.isSelected)
      }

      watch(() => props.isSelected, newValue => {
        if (newValue != selected.value) {
          selected.value = !!newValue
        }
      })

      return {
        selected,
        toggleSelection,
        status,
        ...useDate(),
      }
    }
  }
</script>

<style lang="scss">
  .subscription-list-item {
    padding: 0.352rem 0.5rem 0.352rem 0.5rem;
  }
</style>